// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"448":"aa7a684a","2031":"aa7a684a","7296":"aa7a684a","7303":"aa7a684a"}[chunkId] + ".chunk.css";
};